<template>
    <div class="sfPanel" v-show="isShow">
        <sf-screen v-if="isShow" :isClickEvent="true" />
        <floating-menu className="sfBnt" cacheName="sfPanelBnt" :isToBody="true" :isKeyBoard="false" @click="isShow=!isShow">
            <div class="icon-box">
                <i class="iconfont" :class="isShow?'icon-a-AIdiancai-kai':'icon-a-AIdiancai-guan'"></i>
            </div>
            <span>AI点菜</span>
        </floating-menu>
    </div>
</template>

<script>
import floatingMenu from '../floatingMenu/floatingMenu.vue'

export default {
    name:"sfPanel",
    components:{
        floatingMenu
    },
    data(){
        return {
            //是否显示
            isShow:true,
        }
    },
    mounted(){
    },
    methods:{
      
    },
    unmounted(){
    }
}
</script>

<style scoped>
    .sfPanel{
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:1;
        background-color: #fff;
    }
</style>
<style lang="scss">
    .sfPanel{
        .sfScreen{
            width:100%;
            height:100%;
        }
    }

    .sfBnt.floatingMenu.defaultStyle{
        padding: 0;
        width: auto ;
        top: 26px;
        left: 45%;
        height: 37px;
        font-size: 14px;
        background: #fff;
        overflow: hidden;
        box-shadow:none;
        border:1px solid #487BB2;
        border-radius: 4px;
        display: flex;
        align-items: center;
        box-shadow:2px 2px 5px 1px rgba(0,0,0,0.3);

        .icon-box{
            height:35px;
            display: inline-block;
            text-align: center;
            width: 35px;
            background-color:#487BB2;
            color: #fff;
            font-size: 16px;
            line-height: 35px;
        }

        span{
            padding: 0 5px;
            color: #000;
            font-weight: bold;
        }
    }
</style>